import React, { useEffect, useRef } from 'react';

export default function DefinitionPopover({ word, definition, onClose, position = 'below' }) {
  const ref = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        onClose();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  // On mobile, always position below; on sm+, use the requested position
  const positionClass = position === 'right'
    ? 'top-full left-1/2 -translate-x-1/2 mt-1 sm:top-0 sm:left-full sm:translate-x-0 sm:mt-0 sm:ml-2'
    : 'top-full left-1/2 -translate-x-1/2 mt-1';

  function renderDefinition() {
    if (!definition) return 'No definition available.';
    if (Array.isArray(definition) && definition.length > 1) {
      return definition.map((def, i) => (
        <span key={i}>
          {i > 0 && <br />}
          {`${i + 1}. ${def}`}
        </span>
      ));
    }
    // Single string or single-element array
    return Array.isArray(definition) ? definition[0] : definition;
  }

  return (
    <div
      ref={ref}
      className={`absolute ${positionClass} z-50 bg-white border-2 border-ink p-3 w-56 shadow-md`}
    >
      <p className="text-xs font-serif font-bold text-ink mb-1">{word}</p>
      <p className="text-xs font-body text-ink leading-snug">
        {renderDefinition()}
      </p>
    </div>
  );
}
